export const RouteState = { render: () => null };

export function sectionRoutes({ meta, tabKey, routes }) {
  return routes.map(([path, name, tab, extra = {}]) => ({
    path,
    name,
    component: RouteState,
    ...extra,
    meta: { ...meta, [tabKey]: tab, ...extra.meta },
  }));
}

export function passwordExpiryGate(to, passwordExpired) {
  if (!passwordExpired) return null;
  if (to.name === 'ChangePassword' || to.name === 'Login') return true;
  return { name: 'ChangePassword' };
}
